<template>
  <div class="wrapper">
      <div class="body mb20">
            <div class="body-box mb20 mt20">
                <div class="text-center">
                    <img src="@/assets/cek.png" class="mb20" style="width: 75px;" />
                    <span class="block f12 mb20">Pembayaran Telah dibuatkan</span>
                    <div class="bg-round-blue-o20 p10">
                        <div class="box-horizontal">
                            <span class="text-left">ID Invoice</span>
                            <span class="flex-1 f12 text-right"><strong>#{{data.inv}}</strong></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="body-box mb20 mt20">
                <span class="block mb20"><strong>Pembayaran Via Virtual Account</strong></span>
                <div>
                    <small class="gray mb5">Nama Pelanggan</small>
                    <div class="box-horizontal mb10">
                        <span>{{data.data.name}}</span>
                    </div>
                    <small class="gray">Nama Bank</small>
                    <div class="box-horizontal mb10">
                        <span class="flex-1">{{data.via}}</span>
                        <img class="icon-bank" src="@/assets/alfamart.png" />
                    </div>
                    <small class="gray mb5">Kode Penyedia Pembayaran</small>
                    <div class="box-horizontal mb10">
                        <span class="flex-1">{{data.data.prefix}}</span>
                        <small class="biru p5 pl10 pr10" @click="link.copy(data.data.prefix)"><strong>Salin</strong></small>
                    </div>
                    <small class="gray mb5">Nomor Pembayaran</small>
                    <div class="box-horizontal mb10">
                        <span class="flex-1">{{data.data.payment_code.replace(data.data.prefix, '')}}</span>
                        <small class="biru p5 pl10 pr10" @click="link.copy(data.data.payment_code.replace(data.data.prefix, ''))"><strong>Salin</strong></small>
                    </div>
                    <small class="gray mb5">Total Pembayaran</small>
                    <div class="box-horizontal mb10">
                        <span class="biru">{{myGlobal.ribu(data.data.expected_amount)}}</span>
                    </div>
                    <small class="gray mb5">Expired</small>
                    <div class="box-horizontal mb10">
                        <span>24 Jam dari sekarang</span>
                    </div>
                </div>
            </div>
            <button class="btn btn-info w100" @click="link.history()">Beranda</button>
      </div>

        <div class="toast" v-show="get.data.toastShow">
            <span class="text-center block w100">{{get.data.toastText}}</span>
        </div>
  </div>
</template>

<script>
import myGlobal from '@/MyGlobal'
import inter from '@/Interface'
import { reactive } from '@vue/composition-api'
import store from '@/store/index'
import router from '@/router'

export default {
    components: {
        
    },
    setup() {
        const data = reactive({
                toastShow: false,
                toastText: '',
            params: '',
            data: '',
            inv: '',
            via: ''

        /* modal edit tarif */
        })
        const get = {
            data: reactive({
                this: '',
                hasil: null
            }),
            list() {
                /*
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('Token')
                };
            
                var apiUrl = inter.KategoriList();

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));
                    //data.loading = false;
                    if (x.status == true) {
                        mainData.data = x.data;
                        //theGet.data.Total = x.pesan;
                    } else {
                        
                    }
                })
                */
            },
            confirmPembayaran() {

            }
        }

        const link = {
            copy(text) {
                //var datax = data.data.account_number;
                
                if (sessionStorage.getItem("browserToken") != null) {

                    navigator.clipboard.writeText(text);

                    get.data.toastShow = true;
                    get.data.toastText = "Telah tercopy";
                    setTimeout(function() {
                        get.data.toastShow = false;
                    }, 3000);
                } else {
                    myGlobal.android("copy", text);
                }

                //myGlobal.android("copy", text);
            },
            history() {
                router.push({ 
                    name: 'beranda'
                });
            }
        }
        
        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }

        return {
            data,
            myGlobal,
            inter,
            get,
            redirectx,
            link,
        }

    },
    mounted () {
        this.redirectx.checkApp();

        
        console.log(JSON.stringify(this.data.params));

        // FIX
        this.data.params = this.$route.params;
        this.data.via = this.$route.params.via;
        this.data.data = JSON.parse(this.$route.params.data);
        this.data.inv = this.$route.params.invoice;

        /*
        //COBA
        this.data.via = "PERMATA";
        this.data.data = JSON.parse(` {"is_closed":true,"status":"PENDING","currency":"IDR","owner_id":"616653a1dac5505ba342f4f1","external_id":"adm-1-pid-13572-hid-24111-April-2022-payment-8200-MANDIRI","bank_code":"MANDIRI","merchant_code":"88908","name":"coba no password","account_number":"8890862270285426949","expected_amount":8200,"expiration_date":"2022-04-15T03:34:05.000Z","is_single_use":true,"id":"6254f32e8746e048b6bdc11c"} `);
        this.data.inv = "00000";
        */


        this.get.data.this = this;

        myGlobal.android("close", null)

        //myGlobal.android("toast", this.$route.params.qr);
    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/success/main-retail.vue